// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"faff9fb3","787":"86d24210","978":"0037b25a"}[chunkId] + ".chunk.js";
};